import { Component, OnInit } from '@angular/core';
import { AbstractModal, ModalButtonModel, ModalButtonType } from '@cv-invision/core';
import { ADD_EDIT_CLIENT_IDENTIFIER, ClientIdentifierModel } from '../../model/client-identifier.model';
import { ClientIdentifierListService } from '../../service/client-identifier-list.service';

@Component({
	selector: 'cv-client-identifier-list',
	templateUrl: './client-identifier-list.component.html'
})
export class ClientIdentifierList extends AbstractModal implements OnInit {
	ADD_EDIT_CLIENT_IDENTIFIER = ADD_EDIT_CLIENT_IDENTIFIER;

	public integrationName: string;

	constructor(public clientService: ClientIdentifierListService) {
		super();
	}

	public onDismiss(): void {
		super.onCancel();
	}

	ngOnInit(): void {
		this.integrationName = this.data.integrationName;

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};

		this.buttons.push(cancelButton);
	}

	// Inputs for GenericIdentifierListComponent
	getListFn = () => this.clientService.getList(this.integrationName);
	deleteFn = (integrationName: string, item: ClientIdentifierModel) => this.clientService.delete(integrationName, item);
	getSecondFieldValue = (model: ClientIdentifierModel) => model.integrationClientId;
	modelFactory = () => new ClientIdentifierModel();
}
